<template>
    <div id="catalog-content">
        <b-row>
            <div class="col-md-9">
                <b-tabs v-if="catalogForm">
                    <MultiContent v-model="catalogFormInitialObject" ref="MultiContent" />
                </b-tabs>
                <a-button type="primary" @click="updateContent">
                    {{ $t("message.update") }}
                </a-button>
            </div>
            <div v-if="!!catalogForm" class="col-md-3 content-statistics">
                <h4>İçerik Durum İstatistiği</h4>
                <div class="userInfo">
                    <div class="userInfo first">
                        {{ $t("message.like") }} :
                        <span class="userInfo sec">{{ catalogForm.rate.up }}</span>
                    </div>

                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.disLike") }} :
                            <span class="userInfo sec">{{ catalogForm.rate.down }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
import catalog from "../store/modules/catalog";
import MultiContent from "./MultiContent";
import { toArray2, toObject2 } from "../utils/languageContent";
import { Modal } from "ant-design-vue";
import log2 from "../utils/log2";

const log = log2("CatalogContent");
export default {
    name: "CatalogContent",
    props: ["data", "navigateTo"],
    components: { MultiContent, CKEditor },
    data() {
        return {
            editor: ClassicEditor,
            catalogForm: null,
            editorConfig: () => ({
                // The configuration of the editor.
                removePlugins: ["MediaEmbed", "AutoMediaEmbed"],
            }),
            newCatalogTitle: "",
        };
    },

    mounted() {
        this.catalogForm = _.cloneDeep(this.data);
    },
    computed: {
        ...mapState({
            languages: (state) => state.language.languages,
            catalogs: (state) => state.catalog.catalogs,
            systemLanguages: (state) => state.setting.settings.systemLanguages,
        }),
        catalogFormInitialObject: {
            get() {
                if (!this.systemLanguages) {
                    return [];
                }
                return [
                    {
                        type: "input",
                        field: "name",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.catalogForm.languageContent, `[${lang}].name`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                    {
                        type: "rich",
                        field: "content",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.catalogForm.languageContent, `[${lang}].content`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                ];
            },
            set(v) {
                this.catalogForm.languageContent = this.systemLanguages.reduce((acc, lang) => {
                    acc[lang] = {};
                    for (const _v of v) acc[lang][_v.field] = _v.data[lang];
                    return acc;
                }, {});
            },
        },
        catalogFormInitialObjectTitle: {
            get() {
                return toArray2(this.catalogForm, "languageContent", "name").languageContent;
            },
            set(value) {
                this.catalogForm.languageContent = toObject2(value, "name");
            },
        },
        catalogFormInitialObjectInput: {
            get() {
                return toArray2(this.catalogForm, "languageContent", "content").languageContent;
            },
            set(value) {
                this.catalogForm.languageContent = toObject2(value, "content");
                this.addNewCatalogTitle();
            },
        },
    },
    methods: {
        ...mapActions({
            updateCatalog: "catalog/updateCatalog",
        }),
        titleChangeHandler(value) {
            this.newCatalogTitle = value;
            this.addNewCatalogTitle();
        },
        addNewCatalogTitle() {
            Object.keys(this.newCatalogTitle).forEach((key) => {
                this.catalogForm.languageContent[key].name = this.newCatalogTitle[key];
            });
        },
        onDeleteLanguage(data) {
            this.catalogForm.languageContent = toObject2(data.content, "content");
            this.addNewCatalogTitle();
        },

        success() {
            const modal = Modal.success({
                title: () => this.$t("message.updateCompleted"),
                content: () => this.$t("message.CatalogUpdatedSuccessfully"),
                onOk: () => {
                    this.$emit("finish-update");
                    modal.destroy();
                },
            });
        },

        updateContent() {
            this.updateCatalog(this.catalogForm);
            this.success();
        },
    },
};
</script>

<style lang="scss" scoped>
#catalog-content {
    .inputTitle {
        width: 100%;
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .actionsButton {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .userInfo {
        font-family: Poppins;

        &.first {
            color: #3699ff;
            font-size: 16px;
            font-weight: 500;
            padding-top: 15px;
            line-height: 1;
        }

        &.sec {
            color: #181c32;
            font-size: 14px;
            font-weight: 300;
        }
    }

    .content-statistics {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed;
        flex-direction: column;
    }
}
</style>
<style lang="scss">
//.ck.ck-content.ck-editor__editable {
//    min-height: 500px;
//    max-height: 500px;
//}
</style>
